import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'

import _ from 'lodash'
import { Row, Col, Tabs } from 'core/components/ui'
import { isMobile, isTablet } from 'react-device-detect'

import RenderCar from './RenderCar'

import { AREA } from './constants'

const StyledTabs = styled(Tabs)`
  && .ant-tabs-bar {
    border: none;
  }
  && .ant-tabs-tab.ant-tabs-tab-active {
    color: ${props => props.theme.colors.color1.bg};
  }
`

const VehicleAreas = props => {
  const { sections, onSelect, span, gutter } = props
  const { TabPane } = Tabs
  const getSection = id => _.first(sections.filter(item => item.id === id))

  return (
    <Row type="flex" gutter={!isMobile && gutter}>
      {isMobile && !isTablet ? (
        <Col xs={24}>
          <StyledTabs defaultActiveKey="1">
            <TabPane tab={getSection(AREA.FRONT).label} key={getSection(AREA.FRONT).id}>
              <Col lg={span} sm={12} xs={24}>
                <RenderCar section={getSection(AREA.FRONT)} onSelect={onSelect} />
              </Col>
            </TabPane>
            <TabPane tab={getSection(AREA.BACK).label} key={getSection(AREA.BACK).id}>
              <Col lg={span} sm={12} xs={24}>
                <RenderCar section={getSection(AREA.BACK)} onSelect={onSelect} />
              </Col>
            </TabPane>
            <TabPane tab={getSection(AREA.RIGHT_SIDE).label} key={getSection(AREA.RIGHT_SIDE).id}>
              <Col lg={span} sm={12} xs={24}>
                <RenderCar section={getSection(AREA.RIGHT_SIDE)} onSelect={onSelect} />
              </Col>
            </TabPane>
            <TabPane tab={getSection(AREA.LEFT_SIDE).label} key={getSection(AREA.LEFT_SIDE).id}>
              <Col lg={span} sm={12} xs={24}>
                <RenderCar section={getSection(AREA.LEFT_SIDE)} onSelect={onSelect} />
              </Col>
            </TabPane>
          </StyledTabs>
        </Col>
      ) : (
        <>
          <Col lg={span} sm={12} xs={24}>
            <RenderCar section={getSection(AREA.FRONT)} onSelect={onSelect} />
          </Col>
          <Col lg={span} sm={12} xs={24}>
            <RenderCar section={getSection(AREA.BACK)} onSelect={onSelect} />
          </Col>
          <Col lg={span} sm={12} xs={24}>
            <RenderCar section={getSection(AREA.RIGHT_SIDE)} onSelect={onSelect} />
          </Col>
          <Col lg={span} sm={12} xs={24}>
            <RenderCar section={getSection(AREA.LEFT_SIDE)} onSelect={onSelect} />
          </Col>
        </>
      )}
    </Row>
  )
}

VehicleAreas.defaultProps = {
  onSelect: null,
  span: 12,
  gutter: 100,
  sections: []
}

VehicleAreas.propTypes = {
  sections: PropTypes.arrayOf(PropTypes.shape()),
  onSelect: PropTypes.func,
  span: PropTypes.number,
  gutter: PropTypes.number
}

export default VehicleAreas
